import React, {
  FC,
  InputHTMLAttributes,
  SyntheticEvent,
  useEffect,
  useState,
  ChangeEvent,
} from 'react';
import { FieldValues, UseFormRegister } from 'react-hook-form';

export interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  handleOnChange: (e: SyntheticEvent<HTMLInputElement>) => void;
  hasLabel?: boolean;
  id: string;
  label?: string;
  labelClassName?: string;
  register?: UseFormRegister<FieldValues>;
  toggled?: boolean;
  value: string;
  disabled?: boolean;
}

export const Radio: FC<RadioProps> = ({
  className,
  handleOnChange,
  hasLabel,
  id,
  label,
  labelClassName,
  name,
  register,
  toggled = false,
  value,
  disabled,
  ...rest
}: RadioProps) => {
  /* Checking for missing required props */
  // if (!id)
  //   throw new Error(
  //     `You need to pass a prop called "id" of type string to the Radio component. To learn more about the list of required props for the
  //     Checkbox component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/form-checkbox-radio`
  //   );
  // if (!name)
  //   throw new Error(
  //     `You need to pass a prop called "name" of type string to the Radio component. To learn more about the list of required props for the
  //     Checkbox component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/form-checkbox-radio`
  //   );
  // if (!value)
  //   throw new Error(
  //     `You need to pass a prop called "name" of type string to the Radio component. To learn more about the list of required props for the
  //     Checkbox component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/form-checkbox-radio`
  //   );
  /* Checking for missing required props */

  const radioStyle = `w-[16.67px] h-[16.67px] border-2 border-thryv-gray-light-500 rounded-2xl appearance-none focus:ring-0 focus:ring-offset-0 cursor-pointer
${
  disabled
    ? 'focus:checked:border-thryv-gray-light-500 checked:border-thryv-gray-light-500'
    : 'focus:checked:border-thryv-black-500 checked:border-thryv-black-500'
} `;

  const labelTextStyle = `gap-[9.67px] font-open-sans text-form-text font-normal text-thryv-steel capitalize`;

  const checkedStyles = {
    display: 'initial',
    '--image': `url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='${
      disabled ? 'lightgray' : 'black'
    }' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3.8'/%3e%3c/svg%3e")`,
  };

  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleChecked = (e: ChangeEvent<HTMLInputElement>) => {
    setIsChecked((prevState) => !prevState);
    handleOnChange(e);
  };

  useEffect(() => {
    setIsChecked(toggled);
  }, [toggled]);

  return (
    <label
      className={`inline-flex items-center ${labelClassName || ''} ${
        (hasLabel && label && labelTextStyle) || ''
      }`}
      htmlFor={id || ''}
    >
      <input
        className={`
          ${radioStyle}
          transition-all duration-300 ease-in-out
          ${className || ''}
        `}
        style={checkedStyles}
        type="radio"
        id={id || ''}
        name={name || ''}
        value={value}
        checked={isChecked}
        onChange={handleChecked}
        {...(register && {
          ...register(`${name}`, { required: `${name} is required.` }),
        })}
        disabled={disabled}
        {...rest}
      />
      {(hasLabel && label) || ''}
    </label>
  );
};
